import styled from "styled-components";
import { Button } from "sprout-ui-dom";
import { media } from "sprout-ui-theme";
// Identical to `PostMenu` button
const TopicPageSectionSectionButton = styled(Button)`
  display: inline-flex;
  alignitems: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;

  ${media.target("pointer")} {
    :hover {
      background: #91e5dd;
    }
  }

  :active {
    background: #81ccc4;
  }

  transition: background 0.15s linear;
`;
export default TopicPageSectionSectionButton;
